import {
  ApiResponse,
  TokenData,
  DocumentCategory,
  DocumentSubCategory,
  DocumentOwner,
  DocumentName,
  FieldSetTypes,
  FieldSetInputFields,
} from "../models";
import * as http from "./http";
import ApiService from "./service";

export class LegalDueDiligenceSettingService extends ApiService {
  // Document Category
  public async getDocumentCategories() {
    const url = `${this.apiDomain}/api/document-category`;

    const resposne = await http.get<ApiResponse<DocumentCategory[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDocumentCategory(data: DocumentCategory) {
    const url = `${this.apiDomain}/api/document-category`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateDocumentCategory(data: DocumentCategory, id?: string) {
    const url = `${this.apiDomain}/api/document-category/update/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDocumentCategory(id?: string) {
    const url = `${this.apiDomain}/api/document-category/delete/${id}`;

    const response = await http.remove<ApiResponse<DocumentCategory>>(
      url,
      this.store
    );
    return response.data;
  }

  // DocumentSubCategory
  public async getDocumentSubCategories() {
    const url = `${this.apiDomain}/api/document-sub-category`;

    const resposne = await http.get<ApiResponse<DocumentSubCategory[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDocumentSubCategory(data: DocumentSubCategory) {
    const url = `${this.apiDomain}/api/document-sub-category`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateDocumentSubCategory(
    data: DocumentSubCategory,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/document-sub-category/update/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDocumentSubCategory(id?: string) {
    const url = `${this.apiDomain}/api/document-sub-category/delete/${id}`;

    const response = await http.remove<ApiResponse<DocumentSubCategory>>(
      url,
      this.store
    );
    return response.data;
  }

  // OwnerOfDocument
  public async getDocumentOwners() {
    const url = `${this.apiDomain}/api/document-owner`;

    const resposne = await http.get<ApiResponse<DocumentOwner[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDocumentOwner(data: DocumentOwner) {
    const url = `${this.apiDomain}/api/document-owner`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateDocumentOwner(data: DocumentOwner, id?: string) {
    const url = `${this.apiDomain}/api/document-owner/update/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDocumentOwner(id?: string) {
    const url = `${this.apiDomain}/api/document-owner/delete/${id}`;

    const response = await http.remove<ApiResponse<DocumentOwner>>(
      url,
      this.store
    );
    return response.data;
  }

  // DocumentType
  public async getDocumentNames() {
    const url = `${this.apiDomain}/api/document-name`;

    const resposne = await http.get<ApiResponse<DocumentName[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getFieldSetsInputFields() {
    const url = `${this.apiDomain}/api/company-property-documents/fields`;

    const resposne = await http.get<ApiResponse<FieldSetInputFields[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getFieldSetsTypes() {
    const url = `${this.apiDomain}/api/company-property-documents/types`;

    const resposne = await http.get<ApiResponse<FieldSetTypes[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async createDocumentName(data: DocumentName) {
    const url = `${this.apiDomain}/api/document-name`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateDocumentName(data: DocumentName, id?: string) {
    const url = `${this.apiDomain}/api/document-name/update/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDocumentName(id?: string) {
    const url = `${this.apiDomain}/api/document-name/delete/${id}`;

    const response = await http.remove<ApiResponse<DocumentName>>(
      url,
      this.store
    );
    return response.data;
  }
}
